import React from 'react';
import { Typography, Box } from '@mui/material';

const WHATSAPP_URL = 'https://wa.me/923017444129';

const PoweredByCredit = ({ sx = {} }) => (
  <Box sx={{ textAlign: 'center', mt: 3, ...sx }}>
    <Typography
      component="a"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      variant="body2"
      sx={{
        color: 'text.secondary',
        textDecoration: 'none',
        cursor: 'pointer',
        fontWeight: 500,
        transition: 'color 0.2s ease',
        '&:hover': {
          color: 'primary.main',
          textDecoration: 'underline',
        },
      }}
    >
      Powered by Habib Ur Rehman
    </Typography>
  </Box>
);

export default PoweredByCredit;
